import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { PoolPermissionsFragmentDoc } from './load-pool-permissions.fragments.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreatePermissionMutationVariables = Types.Exact<{
  attributes: Types.PermissionInput;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission?: { __typename?: 'CreatePermissionPayload', successful: boolean, permission?: { __typename?: 'Permission', id: string, role: Types.PermissionRole, user: { __typename?: 'User', id: string, email?: string | null, firstName: string, lastName: string }, subject?: { __typename?: 'Subject', id: string, name: string } | null, pool: { __typename?: 'Pool', id: string, name: string } } | null } | null };

export const CreatePermissionDocument = gql`
    mutation CreatePermission($attributes: PermissionInput!) {
  createPermission(attributes: $attributes) {
    permission {
      ...PoolPermissions
    }
    successful
  }
}
    ${PoolPermissionsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePermissionGQL extends Apollo.Mutation<CreatePermissionMutation, CreatePermissionMutationVariables> {
    document = CreatePermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }